import { Box, Text, LegacyText } from "flicket-ui";
import { AnimatePresence, motion } from "framer-motion";
import styled from "styled-components";

import { useSeatedReservationStore } from "~features/seated-reservation/store";

const Overlay = styled(Box)`
  position: absolute;
  top: 0;
  right: 0;

  width: 100%;
  height: 100%;

  background: rgba(0, 0, 0, 0.4);

  z-index: ${(p) => p.theme.zIndices.overlay + 1000};
`;

export const SeatingChartOverlay = () => {
  const busyState = useSeatedReservationStore((state) => state.busyState);

  return (
    <AnimatePresence>
      {busyState === "finding-best-seats" && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.5 } }}
          transition={{ duration: 0.5 }}
        >
          <Overlay>
            <Box
              p={3}
              backgroundColor="white"
              margin={"auto"}
              maxWidth={300}
              style={{
                borderRadius: "0 0 6px 6px",
              }}
              textAlign="center"
            >
              <LegacyText variant="extraBold.M">
                Finding best available seats...
              </LegacyText>
            </Box>
          </Overlay>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
